import { Box, Button, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect, useRef, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import styled from "styled-components";
import {
  NumberOrderIcon,
  OrderCalender,
} from "../../assets/Icon/OrderDetailIcon";
import NoDataFound from "../../components/common-components/NoDataFound";
import {
  getIncorporation,
  getItin,
  getMessageData,
  handleSendMessage,
  loadSelectedOrderFromStorage,
  setMessage,
  setNewMessage,
} from "../../stores/orders";
import { getCountryList } from "../../stores/incorporation";
import { useAppDispatch } from "../../stores/store";
import { getUserData, localName } from "../../utils/StorageUtils";
import MessageBox from "./MessageBox";
import OrderDetailCard from "./OrderDetailCard";

import BackPageButton from "../../components/common-components/BackPageButton";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import NoOrdersFound from "../../components/common-components/NoOrdersFound";
import MessageEditor from "./MessageEditor";
import OrderDetailTitleBar from "./OrderDetailTitleBar";
// import { getTaxFilingDataById } from "../../stores/taxfiling";
import { getTaxFilingDataByIdAdminOrder } from "../../stores/orders";
import MemberDetailModal from "./MemberDetailModal";

const OrderDetails = () => {
  const { id } = useParams<{ id: string }>();

  // const {id:taxFilingId}  = useParams();
  // console.log(id,"kkk")
  const userData = getUserData();
  const [isMessageBox, setIsMessageBox] = useState<boolean>(false);
  const [isMessageLoading, setIsMessageLoading] = useState(true);
  const messageEndRef = useRef<HTMLDivElement | null>(null);
  const [supportId, setSupportId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [itinPending, setItinPending] = useState(false);
  const [llcPending, setLlcPending] = useState(false);
  const [taxPending, setTaxPending] = useState(false);

  const [sentMessage, setSentMessage] = useState<string[]>([]);
  const [openMemberModal, setOpenMemberModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState<any>(null);

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch<any>(loadSelectedOrderFromStorage());
    dispatch<any>(getCountryList({}));
  }, []);
  const selectedOrder = useSelector((state: any) => state.orders.selectedOrder);
  const taxOrderData = useSelector((state: any) => state.orders.taxOrderData);
  const { countryList } = useSelector((state: any) => state.incorporation);

  const [status, setStatus] = useState("");

  const {
    incorporationDetails,
    itinDetails,
    messageDetails,
    senderName,
    isMessageData,
    fetchMessageDeatil,
    fetchMessgaeData,
    typeMessage,
    selectedFile,
    messageStatus,
    orderDetailstatus,
  } = useSelector((state: any) => state.orders);

  const [hasUsCompany, setHasUsCompany] = useState<any>(
    itinDetails?.data?.has_us_company,
  );
  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; preview: string }[]
  >([]);

  const [data, setData] = useState<any>(null);

  const orderId = id || "";

  const additionalMembers = useMemo(() => {
    const members = data?.data?.additional_members;
    if (!members) return [];
    if (typeof members === "string") {
      try {
        return JSON.parse(members);
      } catch (e) {
        return [];
      }
    }
    return Array.isArray(members) ? members : [];
  }, [data?.data?.additional_members]);

  useEffect(() => {
    if (selectedOrder) {
      refetchData();
    }
  }, [selectedOrder, dispatch, id]);

  useEffect(() => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: "smooth" });
      document.getElementById("messgeContent")?.scrollTo({
        top: document.getElementById("messgeContent")?.scrollHeight,
        behavior: "smooth", // optional, for smooth scrolling
      });
    }
  }, [isMessageBox, fetchMessgaeData]);

  useEffect(() => {
    if (selectedOrder?.productId === 1 && itinDetails) {
      setData(itinDetails);
      setStatus(itinDetails?.data?.status);
      setItinPending(itinDetails?.data?.status ? true : false);
      setHasUsCompany(itinDetails?.data?.has_us_company);
    } else if (selectedOrder?.productId === 2 && incorporationDetails) {
      setData(incorporationDetails);
      setStatus(incorporationDetails?.data?.status);
      setLlcPending(incorporationDetails?.data?.status ? true : false);
      setCountryCode(incorporationDetails?.data?.country_code);
    } else if (selectedOrder?.productId === 3 && taxOrderData) {
      setData({
        data: {
          ...taxOrderData?.tax_filing_file?.file_data,
          documents_by_type: taxOrderData?.documents_by_type,
        },
        order: {
          id: taxOrderData?.tax_filing_file?.id,
          created_at: taxOrderData?.tax_filing_file?.created_at,
          product_name: taxOrderData?.tax_filing_file?.product_name,
          related_orders: taxOrderData?.tax_filing_file?.order_item_id,
          user: taxOrderData?.tax_filing_file?.user,
        },
        user_name: taxOrderData?.user_name,
      });

      setStatus(taxOrderData?.tax_filing_file?.payment_status);
      setTaxPending(taxOrderData?.tax_filing_file?.step >= 2 ? true : false);
    }
  }, [itinDetails, incorporationDetails, selectedOrder, taxOrderData]);
  console.log(status, "status");

  const getMessage = async (showLoader: boolean = true) => {
    if (showLoader) {
      setIsMessageLoading(true);
    }
    try {
      const result = await dispatch<any>(
        getMessageData({ user_id: selectedOrder?.userId, order_id: orderId }),
      );

      if (showLoader) {
        setIsMessageLoading(false);
      }
    } catch (error) {
      // Optional: show error toast or handle error
    } finally {
      if (showLoader) {
        setIsMessageLoading(false);
      } // always stop loading
    }
  };

  useEffect(() => {
    if (selectedOrder?.userId && orderId) {
      getMessage();
    }
  }, [selectedOrder?.userId]);

  const sendMessage = async () => {
    setIsLoading(true);
    const newMessage = typeMessage
      .replace(/<p><br\s*\/?><\/p>/gi, "")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    if (!newMessage && selectedFiles.length === 0) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append("message", typeMessage || ""); // assuming message is a state variable
      // formData.append("sender_name", senderName);
      selectedFiles.forEach((fileObj: any, index: number) => {
        formData.append("files", fileObj.file);
      });
      const newdata = {
        message: typeMessage,
        sender_name: localName,
        files: selectedFiles.map((fileObj: any) => fileObj.file),
      };
      dispatch<any>(setNewMessage(newdata));

      const result = await dispatch<any>(
        handleSendMessage({
          user_id: selectedOrder?.userId,
          order_id: orderId,
          formData,
        }),
      );

      setSentMessage((prev) => [...prev, typeMessage]);

      // getMessage(false);
      dispatch<any>(setMessage(""));
      setSelectedFiles([]);
      setSentMessage([]);
      // setSupportId(result.payload.data.id);
      // if (result.payload.status == 1) {
      //   setIsMessageBox(true);
      // }
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const formatFields = (details: any) => {
    let rawFields: { key: string; title: string }[] = [];

    if (selectedOrder?.productId === 2) {
      rawFields = [
        { key: "first_name", title: "First Name" },
        { key: "middle_name", title: "Middle Name" },
        { key: "last_name", title: "Last Name" },
        { key: "email", title: "Email" },
        { key: "phone_number", title: "Phone Number" },
        { key: "address", title: "Address" },
        { key: "state", title: "State" },
        { key: "city", title: "City" },
        { key: "zip_code", title: "Zip Code" },
        { key: "country_name", title: "Country" },
        { key: "industry_type_name", title: "Industry" },
        { key: "business_description", title: "Business Description" },
        { key: "company_type_name", title: "Company Type" },
        { key: "preferred_name_1", title: "Preferred Company Name 1" },
        { key: "preferred_name_2", title: "Preferred Company Name 2" },
        { key: "preferred_name_3", title: "Preferred Company Name 3" },
        { key: "employees_count", title: "Employees Count" },
        { key: "annual_revenue", title: "Annual Revenue" },
        { key: "company_members", title: "Company Members" },
        { key: "ein_form_file", title: "SS4 Form" },
        { key: "signed_ein_form", title: "SS4 Signed Form" },
        { key: "scan_passport", title: "Scanned Passport" },
        { key: "llc_document_file", title: "Company Formation Document" },
        // { key: "ss4_verified_form_files", title: "EIN Verified Document" },
        { key: "llc_verified_documents", title: "Company Formation Document" },
      ];
    } else if (selectedOrder?.productId === 1) {
      rawFields = [
        { key: "first_name", title: "First Name" },
        { key: "last_name", title: "Last Name" },
        { key: "business_incorporation", title: "Business Incorporation" },
        { key: "ein_document", title: "EIN Document" },
        { key: "w7_form", title: "W7 Form" },
        { key: "w7_signed_form", title: "W7 Signed Form" },
        { key: "scan_passport", title: "Scanned Passport" },
        { key: "form_2848", title: "Form 2848" },
        { key: "form_2848_signed_form", title: "Form 2848 Signed Form" },
        // { key: "verified_form_files", title: "ITIN Verified Document" },
      ];
    } else if (selectedOrder?.productId === 3) {
      const productName = taxOrderData?.tax_filing_file?.product_name;

      if (productName === "Single Member LLC Tax Filling Form") {
        rawFields = [
          { key: "name_surname", title: "Name and Surname" },
          { key: "email", title: "E-Mail" },
          { key: "date_of_birth", title: "Date of Birth" },
          { key: "phone_number", title: "Phone" },
          { key: "country", title: "Country" },
          { key: "option1", title: "Business Details(Option 1)" },
          { key: "option2", title: "Business Details(Option 2)" },
          { key: "business_address", title: "Business Address" },
          { key: "nature_of_business", title: "Nature of Business" },
          { key: "gross_income", title: "Gross Income (USD)" },
          { key: "amount_returns", title: "Amount of Returns (USD)" },
          {
            key: "cost_of_goods_sold",
            title: "Amount of Cost of Goods Sold (USD)",
          },
          { key: "advertising", title: "Advertising (USD)" },
          { key: "commissions_fees", title: "Commissions and Fees (USD)" },
          { key: "contract_labor", title: "Contract Labor (USD)" },
          { key: "insurance", title: "Insurance (other than health) (USD)" },
          {
            key: "interest_bank",
            title: "Interest (paid to the banks, etc.) (USD)",
          },
          {
            key: "legal_professional",
            title: "Legal and Professional Services (USD)",
          },
          { key: "office_expenses", title: "Office Expense (USD)" },
          {
            key: "pension_profit_sharing",
            title: "Pension and Profit Sharing (USD)",
          },
          {
            key: "rent_lease_vehicles",
            title:
              "Rent or Lease: Vehicles, Machinery and equipment, Other business property (rent) (USD)",
          },
          {
            key: "repairs_maintenance",
            title: "Repairs and Maintenance (USD)",
          },
          {
            key: "supplies_tech",
            title: "Supplies (technology/software) (USD)",
          },
          { key: "supplies_furniture", title: "Supplies (furniture) (USD)" },
          { key: "taxes_licenses", title: "Taxes and Licenses (USD)" },
          {
            key: "travel_meals",
            title: "Travel and Meals (50% countable) (USD)",
          },
          { key: "utilities", title: "Utilities (USD)" },
          { key: "wages", title: "Wages (USD)" },
          { key: "other_business", title: "Other (USD)" },
          {
            key: "personal_gross_income",
            title: "Personal Gross Income (USD)",
          },
          { key: "interest_income", title: "Taxable interest Income (USD)" },
          {
            key: "tax_exempt_interest",
            title: "Tax-exempt interest Income (USD)",
          },
          {
            key: "qualified_dividends",
            title: "Qualified dividends Income (USD)",
          },
          {
            key: "taxable_refunds",
            title:
              "Taxable refunds, credits, or offsets of state and local income taxes (USD)",
          },
          {
            key: "scholarship_fellowship",
            title: "Scholarship and fellowship grants (USD)",
          },
          { key: "capital_gain_loss", title: "Capital gain or (loss) (USD)" },
          { key: "other_gains_losses", title: "Other gains or (losses) (USD)" },
          { key: "iras", title: "IRAs, pensions, and annuities (USD)" },
          {
            key: "rental",
            title:
              "Rental real estate, royalties, partnerships, trusts, etc. (USD)",
          },
          { key: "farm_income_loss", title: "Farm income or (loss). (USD)" },
          {
            key: "unemployment_compensation",
            title: "Unemployment compensation (USD)",
          },
          { key: "other_income", title: "Other income (USD)" },
          { key: "total_contributions", title: "Total Contributions" },
          { key: "total_distributions", title: "Total Distributions" },
          { key: "company_documents", title: "Company Documents" },
          { key: "ein_document", title: "EIN" },
          { key: "itin_document", title: "ITIN" },
          { key: "passport_scan", title: "Passport" },
        ];
      } else if (productName === "C-Corp Tax Filling Form") {
        rawFields = [
          { key: "name_surname", title: "Name and Surname" },
          { key: "email", title: "E-Mail" },
          { key: "date_of_birth", title: "Date of Birth" },
          { key: "country", title: "Country" },
          { key: "business_address", title: "Business Address" },
          { key: "nature_of_business", title: "Nature of Business" },
          { key: "phone_number", title: "Phone" },
          // { key: "country_code", title: "Country Code" },
          { key: "gross_income", title: "Gross Income (USD)" },
          { key: "amount_returns", title: "Amount of Returns (USD)" },
          { key: "cost_of_goods_sold", title: "Cost of Goods Sold (USD)" },
          { key: "advertising", title: "Advertising (USD)" },
          { key: "commissions_fees", title: "Commissions and Fees (USD)" },
          { key: "contract_labor", title: "Contract Labor (USD)" },
          { key: "insurance", title: "Insurance (other than health) (USD)" },
          { key: "interest_bank", title: "Interest paid to banks (USD)" },
          {
            key: "legal_professional",
            title: "Legal and Professional Services (USD)",
          },
          { key: "office_expenses", title: "Office Expenses (USD)" },
          {
            key: "pension_profit_sharing",
            title: "Pension and Profit Sharing (USD)",
          },
          {
            key: "rent_lease_vehicles",
            title: "Rent or Lease: Vehicles, Machinery and equipment (USD)",
          },
          {
            key: "repairs_maintenance",
            title: "Repairs and Maintenance (USD)",
          },
          {
            key: "supplies_materials",
            title: "Supplies (technology/software) (USD)",
          },
          { key: "supplies_stationary", title: "Supplies (furniture) (USD)" },
          { key: "taxes_licenses", title: "Taxes and Licenses (USD)" },
          {
            key: "travel_meals",
            title: "Travel and Meals (50% countable) (USD)",
          },
          { key: "utilities", title: "Utilities (USD)" },
          { key: "wages", title: "Wages (USD)" },
          { key: "other_business", title: "Other Business Expenses (USD)" },
          {
            key: "personal_gross_income",
            title: "Personal Gross Income (USD)",
          },
          { key: "interest_income", title: "Taxable Interest Income (USD)" },
          {
            key: "tax_exempt_interest",
            title: "Tax-exempt Interest Income (USD)",
          },
          {
            key: "qualified_dividends",
            title: "Qualified Dividends Income (USD)",
          },
          { key: "taxable_refunds", title: "Taxable Refunds (USD)" },
          {
            key: "scholarship_fellowship_grants",
            title: "Scholarship and Fellowship Grants (USD)",
          },
          { key: "capital_gain_loss", title: "Capital Gain or Loss (USD)" },
          { key: "other_gains_losses", title: "Other Gains or Losses (USD)" },
          {
            key: "ira_distributions",
            title: "IRA Distributions/Pensions and Annuities (USD)",
          },
          { key: "farm_income_loss", title: "Farm Income or Loss (USD)" },
          {
            key: "unemployment_compensation",
            title: "Unemployment Compensation (USD)",
          },
          { key: "other_income", title: "Other Income (USD)" },
          { key: "company_documents", title: "Company Documents" },
          { key: "ein_document", title: "EIN" },
          { key: "itin_document", title: "ITIN" },
          { key: "passport_scan", title: "Passport" },
        ];
      } else if (productName === "Multi-Member LLC Tax Filling Form") {
        rawFields = [
          { key: "name_surname", title: "Name and Surname" },
          { key: "email", title: "E-Mail" },
          { key: "date_of_birth", title: "Date of Birth" },
          { key: "country", title: "Country" },
          { key: "business_address", title: "Business Address" },
          { key: "nature_of_business", title: "Nature of Business" },
          { key: "phone_number", title: "Phone" },
          // { key: "country_code", title: "Country Code" },
          { key: "additional_members", title: "Additional Members" },
          { key: "partnership_structure", title: "Partnership Structure" },
          { key: "gross_income", title: "Gross Income (USD)" },
          { key: "amount_returns", title: "Amount of Returns (USD)" },
          { key: "cost_of_goods_sold", title: "Cost of Goods Sold (USD)" },
          { key: "advertising", title: "Advertising (USD)" },
          { key: "commissions_fees", title: "Commissions and Fees (USD)" },
          { key: "contract_labor", title: "Contract Labor (USD)" },
          { key: "insurance", title: "Insurance (other than health) (USD)" },
          { key: "interest_bank", title: "Interest paid to banks (USD)" },
          {
            key: "legal_professional",
            title: "Legal and Professional Services (USD)",
          },
          { key: "office_expenses", title: "Office Expenses (USD)" },
          {
            key: "pension_profit_sharing",
            title: "Pension and Profit Sharing (USD)",
          },
          {
            key: "rent_lease_vehicles",
            title: "Rent or Lease Vehicles, Machinery and equipment (USD)",
          },
          {
            key: "repairs_maintenance",
            title: "Repairs and Maintenance (USD)",
          },
          {
            key: "supplies_materials",
            title: "Supplies Technology software (USD)",
          },
          { key: "supplies_stationary", title: "Supplies Furnished (USD)" },
          { key: "taxes_licenses", title: "Taxes and Licenses (USD)" },
          {
            key: "travel_meals",
            title: "Travel and Meals (50% countable) (USD)",
          },
          { key: "utilities", title: "Utilities (USD)" },
          { key: "wages", title: "Wages (USD)" },
          { key: "other_business", title: "Other Business Expenses (USD)" },
          {
            key: "personal_gross_income",
            title: "Personal Gross Income (USD)",
          },
          { key: "interest_income", title: "Taxable Interest Income (USD)" },
          {
            key: "tax_exempt_interest",
            title: "Tax-exempt Interest Income (USD)",
          },
          {
            key: "qualified_dividends",
            title: "Qualified Dividends Income (USD)",
          },
          { key: "taxable_refunds", title: "Taxable Refunds (USD)" },
          {
            key: "scholarship_fellowship_grants",
            title: "Scholarship and Fellowship Grants (USD)",
          },
          { key: "capital_gain_loss", title: "Capital Gain or Loss (USD)" },
          { key: "other_gains_losses", title: "Other Gains or Losses (USD)" },
          {
            key: "ira_distributions",
            title: "IRA Distributions/Pensions and Annuities (USD)",
          },
          { key: "farm_income_loss", title: "Farm Income or Loss (USD)" },
          {
            key: "unemployment_compensation",
            title: "Unemployment Compensation (USD)",
          },
          { key: "other_income", title: "Other Income (USD)" },
          { key: "company_documents", title: "Company Documents" },
          { key: "ein_document", title: "EIN Documents" },
          { key: "passport_scan", title: "Passport Scan" },
          { key: "itin_document", title: "ITIN Documents" },
        ];
      } else {
        // Default fields for other tax filing forms
        rawFields = [
          { key: "name_surname", title: "Name and Surname" },
          { key: "email", title: "Email" },
          { key: "date_of_birth", title: "Date of Birth" },
          { key: "phone_number", title: "Phone Number" },

          // { key: "country_code", title: "Country Code" },
          { key: "country", title: "Country" },
          { key: "us_address", title: "US Address" },
          { key: "foreign_address", title: "Foreign Address" },
          { key: "additional_members", title: "Additional Members" },
          { key: "partnership_structure", title: "Partnership Structure" },
          { key: "business_address", title: "Business Address" },
          { key: "nature_of_business", title: "Nature of Business" },
          { key: "gross_income", title: "Gross Income" },
          { key: "amount_returns", title: "Amount of Returns" },
          { key: "cost_of_goods_sold", title: "Cost of Goods Sold" },
          { key: "advertising", title: "Advertising" },
          { key: "commissions_fees", title: "Commissions and Fees" },
          { key: "contract_labor", title: "Contract Labor" },
          { key: "insurance", title: "Insurance" },
          { key: "interest_bank", title: "Interest paid to banks" },
          {
            key: "legal_professional",
            title: "Legal and Professional Services",
          },
          { key: "office_expenses", title: "Office Expenses" },
          {
            key: "pension_profit_sharing",
            title: "Pension and Profit Sharing",
          },
          {
            key: "rent_lease_vehicles",
            title: "Rent or Lease: Vehicles, Machinery and equipment",
          },
          { key: "repairs_maintenance", title: "Repairs and Maintenance" },
          { key: "supplies_materials", title: "Supplies Materials" },
          { key: "supplies_stationary", title: "Supplies Stationary" },
          { key: "taxes_licenses", title: "Taxes and Licenses" },
          { key: "travel_meals", title: "Travel and Meals (50% deductible)" },
          { key: "utilities", title: "Utilities" },
          { key: "wages", title: "Wages" },
          { key: "other_business", title: "Other Business Expenses" },
          { key: "personal_gross_income", title: "Personal Gross Income" },
          { key: "interest_income", title: "Interest Income" },
          { key: "tax_exempt_interest", title: "Tax-exempt Interest Income" },
          { key: "qualified_dividends", title: "Qualified Dividends Income" },
          { key: "taxable_refunds", title: "Taxable Refunds" },
          {
            key: "scholarship_fellowship_grants",
            title: "Scholarship Fellowship Grants",
          },
          { key: "capital_gain_loss", title: "Capital Gain or (Loss)" },
          { key: "other_gains_losses", title: "Other Gains or (Losses)" },
          { key: "ira_distributions", title: "IRA Distributions" },
          { key: "pensions_annuities", title: "Pensions and Annuities" },
          { key: "farm_income_loss", title: "Farm Income or (Loss)" },
          {
            key: "unemployment_compensation",
            title: "Unemployment Compensation",
          },
          { key: "other_income", title: "Other Income" },
          { key: "passport_scan", title: "Passport Scan" },
          { key: "company_documents", title: "Company Documents" },
          { key: "ein_document", title: "EIN Documents" },
          { key: "itin_document", title: "ITIN Documents" },
        ];
      }
    }

    const expandedFields = rawFields.flatMap((field) => {
      const value = details?.[field.key];

      if (field.key === "llc_document_file") {
        const hasVerified =
          Array.isArray(details?.llc_verified_documents) &&
          details.llc_verified_documents.length > 0;

        return {
          title: hasVerified
            ? "Company Formation Document 1"
            : "Company Formation Document",
          value,
          key: field.key,
          attribute: field.key,
        };
      }

      // Handle phone number to remove any minus sign prefix
      if (field.key === "phone_number") {
        let phoneValue = String(value || "");
        console.log("Original phone value:", phoneValue, "Type:", typeof value);

        // Remove minus sign if present
        if (phoneValue.startsWith("-")) {
          phoneValue = phoneValue.substring(1);
        }

        // Also handle if it's a negative number
        if (typeof value === "number" && value < 0) {
          phoneValue = String(Math.abs(value));
        }

        console.log("Final phone value being returned:", phoneValue);
        return {
          title: field.title,
          value: phoneValue,
          key: field.key,
          attribute: field.key,
        };
      }

      // Handle passport_scan object for tax filing
      if (field.key === "passport_scan") {
        const passportUrl = taxOrderData?.tax_filing_file?.passport;
        // console.log(passportUrl, "=====taxOrderData passport");

        if (passportUrl) {
          // Extract filename from URL for display
          const filename = passportUrl.split("/").pop() || "passport.pdf";
          return {
            title: field.title,
            value: passportUrl, // Use full URL for download/preview
            key: field.key,
            attribute: field.key,
            hasDocument: true,
            displayValue: filename, // Add display value for showing just the filename
          };
        } else {
          return {
            title: field.title,
            value: "No files",
            key: field.key,
            attribute: field.key,
            hasDocument: false,
          };
        }
      }

      // Handle document fields for tax filing
      if (field.key === "company_documents") {
        const companyDocs = details?.documents_by_type?.company;
        console.log(companyDocs, "=====companyDocs");
        // Get all document URLs as an array (since companyDocs is an array of objects)
        const documentUrls =
          companyDocs?.map((doc: any) => doc.document_file_url) || [];
        console.log(documentUrls, "=====companyDocs document URLs");
        return {
          title: field.title,
          value: documentUrls, // Pass the array of URLs
          key: field.key,
          attribute: field.key,
          hasDocument: true,
        };
      }

      if (field.key === "ein_document") {
        const einDocs = details?.documents_by_type?.ein;
        const documentUrls =
          einDocs?.map((doc: any) => doc.document_file_url) || [];
        return {
          title: field.title,
          value: documentUrls, // Pass the array of URLs
          key: field.key,
          attribute: field.key,
          hasDocument: true,
        };
      }

      if (field.key === "itin_document") {
        const itinDocs = details?.documents_by_type?.itin;
        const documentUrls =
          itinDocs?.map((doc: any) => doc.document_file_url) || [];
        return {
          title: field.title,
          value: documentUrls, // Pass the array of URLs
          key: field.key,
          attribute: field.key,
          hasDocument: true,
        };
      }

      // Handle array fields and expand them
      if (Array.isArray(value)) {
        return value.map((item, idx) => ({
          title: `${field.title} ${idx + 2}`,
          value: item,
          key: `${field.key}_${idx}`,
          attribute: field.key,
        }));
      }

      // Skip empty non-array values
      if (!value) return [];

      return {
        title: field.title,
        value,
        key: field.key,
        attribute: field.key,
      };
    });

    return expandedFields.map((item, index) => ({
      ...item,
      border: index !== expandedFields.length - 1,
    }));
  };

  const orderBasicDetail = (details: any) => {
    const items = [
      {
        key: "id",
        title: "Number",
        icon: <NumberOrderIcon />,
      },
      {
        key: "created_at",
        title: "Created",
        icon: <OrderCalender />,
      },
      {
        key: "product_name",
        title: "Service",
      },
      {
        key: "related_orders",
        title: "Related",
      },
    ];

    const filteredItems = items
      .map((item) => ({
        title: item.title,
        value: details?.[item.key] ?? "",
        icon: item.icon,
      }))
      .filter((item) => item.value);

    return filteredItems.map((item, index) => ({
      ...item,
      border: index !== filteredItems.length - 1,
    }));
  };

  const clientBasicDetail = (details: any) => {
    // For tax filing data, get username from the user object or user_name field
    let userName = "";
    if (selectedOrder?.productId === 3) {
      // For tax filing, check if we have user_name directly or from user object
      userName =
        details?.user_name ||
        (details?.order?.user
          ? `${details.order.user.first_name} ${details.order.user.last_name}`
          : "") ||
        taxOrderData?.user_name ||
        (taxOrderData?.tax_filing_file?.user
          ? `${taxOrderData.tax_filing_file.user.first_name} ${taxOrderData.tax_filing_file.user.last_name}`
          : "");
    } else {
      // For other product types, use the existing logic
      userName = details?.["user_name"] ?? "";
    }

    return [
      {
        key: "user_name",
        title: "Users",
        value: userName,
      },
    ]
      .map((item) => ({
        title: item.title,
        value: item.value || (details?.[item.key] ?? ""),
        border: false,
      }))
      .filter((item) => item.value);
  };

  const refetchData = async () => {
    if (selectedOrder?.productId === 1) {
      await dispatch<any>(getItin({ order_id: id }));
    } else if (selectedOrder?.productId === 2) {
      await dispatch<any>(getIncorporation({ order_id: id }));
    } else if (selectedOrder?.productId === 3) {
      await dispatch<any>(getTaxFilingDataByIdAdminOrder({ order_id: id }));
    }
  };

  return (
    <StyledBox>
      <BackPageButton />
      <OrderDetailTitleBar
        title={
          selectedOrder?.productId === 2
            ? "LLC + EIN Applications"
            : selectedOrder?.productId === 3
              ? taxOrderData?.tax_filing_file?.product_name ||
                "Tax Filing Application"
              : "ITIN Application"
        }
        status={status ? status : ""}
        productId={selectedOrder?.productId}
        onSuccessUpload={refetchData}
        loading={orderDetailstatus === "loading"}
        taxOrderData={taxOrderData}
      />

      <Box
        sx={{
          borderBottom: "2px solid #EAF1FA",
          mb: 2,
          position: "relative",
          paddingY: "20px",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            color: "#2977CC",
            fontWeight: 600,
            fontSize: "20px",
            borderBottom: "2px solid #2977CC",
            display: "inline-block",
            pb: 0.5,
            position: "absolute",
            bottom: "-2px",
          }}
        >
          Details
        </Typography>
      </Box>
      {/* Grid Conatiner To show Detail */}
      <Grid container spacing={2}>
        <StyledGridBox
          size={{ xs: 12, md: 8 }}
          sx={{
            border: "2px solid #EAF1FA",
            borderRadius: "12px",
            // padding: "20px",
          }}
        >
          <Box sx={{ padding: 2 }}>
            {orderDetailstatus === "loading" ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "400px",
                  width: "100%",
                  border: "1px solid #EAF1FA",
                  borderRadius: "12px",
                  backgroundColor: "#FFF",
                }}
              >
                <ListLoadingNew />
              </Box>
            ) : data?.data &&
              orderDetailstatus != "loading" &&
              formatFields(data?.data).length > 0 ? (
              selectedOrder?.productId === 3 &&
              taxOrderData?.tax_filing_file?.step === 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "400px",
                    width: "100%",
                    border: "1px solid #EAF1FA",
                    borderRadius: "12px",
                    backgroundColor: "#FFF",
                  }}
                >
                  <NoOrdersFound title="Taxfiling is not submitted yet" />
                </Box>
              ) : (
                <OrderDetailCard
                  orderFormData={formatFields(data?.data)}
                  isViewButton={true}
                  cardTitle="Form Fields"
                  countryCode={countryCode}
                  hasUsCompany={hasUsCompany}
                  hasItinDocument={data?.data?.verified_form_files}
                  hasEINDocument={data?.data?.ss4_verified_documents}
                  data={data}
                />
              )
            ) : orderDetailstatus != "loading" &&
              formatFields(data?.data).length === 0 ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "400px",
                  width: "100%",
                  border: "1px solid #EAF1FA",
                  borderRadius: "12px",
                  backgroundColor: "#FFF",
                }}
              >
                <NoOrdersFound title="No Data Found" />
              </Box>
            ) : null}
          </Box>
          <Grid size={{ xs: 12, md: 12 }} sx={{ paddingY: "20px" }}>
            <Typography
              variant="subtitle1"
              sx={{
                color: "#2977CC",
                fontWeight: 600,
                fontSize: "22px",
                borderBottom: "2px solid #2977CC",
                display: "inline-block",
                pb: 0.5,
                marginX: 2,
              }}
            >
              Message
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            {isMessageLoading ? (
              <Box>
                <ListLoadingNew isStart={true} />
              </Box>
            ) : fetchMessgaeData.length == 0 &&
              !isMessageLoading &&
              !isMessageBox ? (
              <Box ref={messageEndRef}>
                <NoDataFound
                  isMessage={true}
                  title="No Conversation Yet"
                  subTitle="No conversation has been initiated yet. Once a message is sent or received, the conversation history will appear here."
                  handleData={() => {
                    getMessage(false);
                    setIsMessageBox(true);
                  }}
                  status={itinPending || llcPending || taxPending}
                />
              </Box>
            ) : isMessageData && isMessageBox ? (
              <>
                <Grid
                  size={{ xs: 12, md: 12 }}
                  sx={{ padding: 2 }}
                  ref={messageEndRef}
                >
                  <Box ref={messageEndRef}>
                    <MessageBox
                      fetchMessgaeData={fetchMessgaeData}
                      sentData={messageDetails}
                      sending={isLoading}
                    />
                  </Box>
                  <Box>
                    <MessageEditor
                      handleSend={() => {
                        sendMessage();
                      }}
                      selectedFiles={selectedFiles}
                      setSelectedFiles={setSelectedFiles}
                      isMessageBox={setIsMessageBox}
                    />
                  </Box>
                </Grid>
              </>
            ) : (
              <Box ref={messageEndRef}>
                <MessageBox
                  fetchMessgaeData={fetchMessgaeData}
                  sentData={messageDetails}
                  sending={isLoading}
                />
                <Grid
                  size={{ xs: 12, md: 12 }}
                  sx={{ borderBottom: "2px solid #EAF1FA", padding: 2 }}
                  ref={messageEndRef}
                >
                  {isMessageBox ? (
                    <MessageEditor
                      selectedFiles={selectedFiles}
                      setSelectedFiles={setSelectedFiles}
                      handleSend={sendMessage}
                      isMessageBox={setIsMessageBox}
                    />
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      <Button
                        type="submit"
                        sx={{
                          width: "120px",
                          fontSize: "13.3px",
                          fontWeight: 600,
                          color: "#fff",
                          background:
                            "linear-gradient(98.24deg, #2977CC 4.13%, #1D538F 128.24%)",
                        }}
                        onClick={() => setIsMessageBox(true)}
                      >
                        Reply
                      </Button>
                    </Box>
                  )}
                </Grid>
              </Box>
            )}
          </Grid>
        </StyledGridBox>

        <Grid size={{ xs: 12, md: 4 }}>
          {orderDetailstatus === "loading" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "400px",
                width: "100%",
                border: "1px solid #EAF1FA",
                borderRadius: "12px",
                backgroundColor: "#FFF",
              }}
            >
              <ListLoadingNew />
            </Box>
          ) : data?.data &&
            orderDetailstatus != "loading" &&
            orderBasicDetail(data?.order).length > 0 ? (
            <OrderDetailCard
              orderFormData={data?.order ? orderBasicDetail(data?.order) : []}
              isClassName={true}
              cardTitle="Details"
            />
          ) : orderDetailstatus != "loading" &&
            orderBasicDetail(data?.order).length > 0 ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "300px",
                width: "100%",
                border: "1px solid #EAF1FA",
                borderRadius: "12px",
                backgroundColor: "#FFF",
              }}
            >
              <NoOrdersFound title="No Data Found" showImage={false} />
            </Box>
          ) : null}

          {orderDetailstatus === "loading" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "400px",
                width: "100%",
                border: "1px solid #EAF1FA",
                borderRadius: "12px",
                backgroundColor: "#FFF",
              }}
            >
              <ListLoadingNew />
            </Box>
          ) : data?.data &&
            orderDetailstatus != "loading" &&
            clientBasicDetail(data).length > 0 ? (
            <OrderDetailCard
              orderFormData={data ? clientBasicDetail(data) : []}
              isClassName={true}
              cardTitle="Client"
              margin={true}
            />
          ) : orderDetailstatus != "loading" &&
            clientBasicDetail(data).length > 0 ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "300px",
                marginTop: "8px",
                width: "100%",
                border: "1px solid #EAF1FA",
                borderRadius: "12px",
                backgroundColor: "#FFF",
              }}
            >
              <NoOrdersFound title="No Data Found" showImage={false} />
            </Box>
          ) : null}

          {/* Additional Members Section */}
          {selectedOrder?.productId === 2 &&
            data?.data &&
            orderDetailstatus !== "loading" &&
            additionalMembers.length > 0 && (
              <StyledGridBoxChild
                size={{ xs: 12, md: 12 }}
                sx={{ marginTop: "20px" }}
              >
                <OrderTitle
                  sx={{ fontWeight: "600 !important", paddingTop: "0px" }}
                >
                  Additional Members
                </OrderTitle>
                <Box sx={{ mt: 1 }}>
                  {additionalMembers.map((member: any, index: number) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingY: "12px",
                        borderBottom:
                          index !== data.data.additional_members.length - 1
                            ? "1px solid #EAF1FACC"
                            : "none",
                      }}
                    >
                      <Box>
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: 600, color: "#01060B" }}
                        >
                          {member.first_name} {member.last_name}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: "#6C6F71", display: "block" }}
                        >
                          {member.email || "No email provided"}
                        </Typography>
                      </Box>
                      <Button
                        variant="text"
                        size="small"
                        sx={{
                          textTransform: "none",
                          color: "#2977CC",
                          fontWeight: 600,
                          fontSize: "13px",
                        }}
                        onClick={() => {
                          const countryName =
                            countryList?.find(
                              (c: any) => c.id === member.country,
                            )?.name || member.country;
                          setSelectedMember({
                            ...member,
                            country_name: countryName,
                          });
                          setOpenMemberModal(true);
                        }}
                      >
                        View Details
                      </Button>
                    </Box>
                  ))}
                </Box>
              </StyledGridBoxChild>
            )}
        </Grid>
      </Grid>
      <MemberDetailModal
        open={openMemberModal}
        onClose={() => setOpenMemberModal(false)}
        member={selectedMember}
      />
    </StyledBox>
  );
};

export default OrderDetails;
interface OrderTitleProps {
  isClassName?: boolean;
}
export const StyledBox = styled(Box)({
  background: "#ffffff",
  boxShadow: "0px 2px 40px 0px #DDE3EA33",
  borderRadius: "10px",
  padding: "16px",
});
export const StyledGridBox = styled(Grid)(({ theme }) => ({
  border: "2px solid #EAF1FA",
  borderRadius: "12px",
  // padding: "10px",
}));
export const OrderTitle = styled(Typography)<OrderTitleProps>(
  ({ isClassName }) => ({
    fontSize: "19px !important",
    color: "#01060B",
    paddingTop: isClassName ? "10px" : "20px",
    paddingBottom: "10px",
  }),
);
export const StyledGridBoxChild = styled(Grid)(({ theme }) => ({
  border: "1px solid #EAF1FA",
  borderRadius: "8px",
  padding: "20px",
}));
export const FormTItle = styled(Typography)({
  fontSize: "14px !important",
  color: "#6C6F71",
  fontWeight: 500,
});
export const FormTItleValue = styled(Typography)({
  width: "50%",
  fontSize: "14px !important",
  color: "#01060B",
  fontWeight: 500,
  display: "flex",
  // alignItems: "center",
});
